import { render, staticRenderFns } from "./_Generic.vue?vue&type=template&id=195f0ad7&"
import script from "./_Generic.vue?vue&type=script&lang=ts&"
export * from "./_Generic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports